<template>
  <div class="hello" style="padding-top: 50px;">
    <Carousel autoplay :autoplay-speed="3500" v-model="value1" loop radius-dot arrow="never">
      <CarouselItem>
        <div class="demo-carousel">
          <img src="../../static/image/indexBack.png" class="fullWidth" />
        </div>
      </CarouselItem>

      <CarouselItem>
        <div class="demo-carousel">
          <img src="../../static/image/indexBack2.png" class="fullWidth" />
        </div>
      </CarouselItem>
    </Carousel>
    <div style="height: 50px;"></div>
    <div>
      <img class="centerLR" src="../../static/image/womendefuwu.png" style="width: 20%;" />
    </div>
    <div style="height: 30px;" @mouseenter="clearHover()"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="4" class="alignR">
        <div
          class="swiper-button-prev"
          style="left:auto; height:50px; outline: none; !important;right: 50px !important;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAxCAYAAADEIbk7AAADI0lEQVRYR7WWyW4TQRRF74tsbDIwS/wJEjvEKCDMUkAoDAHRVXskJOaEQLLIzsrQ1UoU4QUkTpiW/AO/wGdgjOPWQ88qRx27bffkWtlSXCf33ftuN2GAZ2Vl5QQRjRHRLxoUZ3V19Yjv+2UAx4lodiAgY8xBZt4kogtWyLPMQcaYYQsZFwgzv/N9fyFT0Nra2lij0dgGcN4qmVZKzcjnzEDLy8uHh4aGtonodEuJ1vptKwOZgBYXF4/m8/lNAGfsxR+UUq+CQUsNsuMSyMVukNSjazcewIxSajpsZRIrKpVKBwqFwtfAuHaNzwwky9hoNLZaxgOYVUq96bX8sRVFMT61oqWlpVFJFzNfahpM9N5xnNdRaiyyonK5PFKtVjeIqLnxvYxPrEiMLxaL28x8LgkkUrzbjY8zrsgLK7WSy+XEk6YSZp7XWr+I4kn733T1SIzP5XIbAC7bH/WNcOx4i/G1Wq3SSheAnssYRWGHInloAZCqP5vU+L6pC9n4jhaO8t/3BK2vrx+q1+vSwq2H1pxS6mXSi0PDELKMqYwPVWSMOUZEH63xdQDz3ao+jTryPO85M8/ZS7aUUhNpLuz2W3Jd9yQR/QQwBuA3Mz/VWv/IGtaMt+u614joM4D9AOrM/FBrLd8zO7t75HneDWaWywsAqsz8SGstKczk7FlYq0wuF9hfZp7UWsvjOvXpaAbP88aZWTpuxI5xIgvPQkvVdd0rRPQJwKjAiOiu4zhf0sjq2t7GmOsARJmMcYeZH6QJSM9Hueu6N20a96UNSN93BjvGLausZsf4Le4Y+4LkQhsQiX7TM2aOHZBIILvUewICYFIpJUojncigQINUAIhn/5h5KmpAYoHsGG/ZBskD+ANgKoqy2KCAZzK2oigDcEcp9b3XDBOBAp5JQCI1SGKQVXaVmaVBmjAiuuc4jnjYcVKBLExaXxpEAiJF/DgsIKlBdoztDSJ1Ja9suycTkNxmjJE3WgmIPDwl+reDrZ8ZKGypgw2SKSgQEEnjsK2r+0qpSuagwFJLGiUgO0R0aiCgQBoXAPhENDkwEDOTMeYJEZHv+5X/LqGWHkgIOFAAAAAASUVORK5CYII=)  no-repeat !important;"
        ></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </Col>
      <Col span="16" style="height:220px;">
        <div class="swiper-container" style="height:220px;">
          <div class="swiper-wrapper bnn">
            <div
              class="swiper-slide"
              style="border-radius: 5px;position: relative;"
              v-bind:style="{height:slideHeight}"
              v-for="(item,index) in slideList"
              :key="index"
            >
              <router-link
                :to="(item.linkTo)"
                @mouseenter.native="hoverThis(index)"
                class="colorW"
                @click.native="clickMoban(index)"
              >
                <div class="BTjuzhongP">
                  <div class="BTjuzhongC" style="padding-top: 50px;">
                    <div>
                      <img :src="item.icon" style="width: 50px;height: 50px" />
                    </div>
                    <div style="padding-top: 20px;"></div>
                    <div
                      style="font-family: 'Microsoft YaHei';font-size: 24px;color: #333333;"
                    >{{item.title}}</div>
                  </div>
                </div>
                <div
                  v-show="item.isShow"
                  style="position: absolute;left: 0;right: 0;;bottom: 0;top: 0;height:220px;background: #f7f7f7;border-radius: 5px;"
                >
                  <div class="BTjuzhongP">
                    <div class="BTjuzhongC">
                      <div
                        class="app-title-hover"
                        style="font-size:24px;font-family: 'Microsoft YaHei';color: #999999;padding-top:40px;"
                      >{{item.title}}</div>
                      <div style="height: 30px;"></div>
                      <ul>
                        <li
                          v-for="(items,indexs) in item.children"
                          :key="indexs"
                          style="font-size: 18px;font-family: 'Microsoft YaHei';color: #999999;list-style: none"
                        >{{items.name}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </Col>
      <Col span="4">
        <div
          class="swiper-button-next"
          style="outline: none; height:50px; background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAxCAYAAADEIbk7AAADMklEQVRYR7WYyW4TQRCG/9IMxhgkxDPwCnDhBbixBC9JDkZRohlnUW45EPb1gMQxUXcjdoQAiT0BQUjEmTfhwJrNjq0UqqgdORMv45nxnGypXZ+q/v+vloe01geZ+QgzL4+Ojn5Hjx4yxpxg5osAfjiOUxwZGfnVCxZpracA3JbizPyZiAq+7/9NGkYzMzMHHMeZIqJLFjZnYWtJwqheTGt9GcAV+/2L67rZ4eHh5aRg2yApqJS62tDZ0ubmZnZsbOx3ErAdICmotb4B4LwtvlitVgsTExM/48J2gZrAPrmuW4g7xqYgCxO9RDdxY2yDtARZWKNBFiuVSt/k5OS/KGNsC7KwawAk0NLZkuu6uSih7ghKyiChQAIzxlxn5gvymYg+ihvHx8dXwo4xNKiZQTKZTH+xWFwNA+sKFIQR0UK5XM6GMUjXoOAYwxokEsiuq1tEdM5qtlCr1Qrt1lVkUND6AOZrtVp/K4PEAgVDLW5Mp9P5ZgaJDQoaBMBXANng5ZkIKBjqZgZJDGRhNwFM1y/PVCpVGBoa+rNlmDBh6+aM1rpxN87VQ504qEEzsX5KDMLMZ3sCsrCXAHI2Z9M9ASmlThLRHQCHASwz8/HEQUqpASJ6KGMDsM7MA6VS6V2iIKVUgYjuA8gAqBDRgOd5bxJ1nVKqj4ieAtgnEGYuSCd1xybSkdVExJdxrRJRv+d5c42xiA0yxpxh5mcWssLMg6VS6UMwe7FAVvhHAPbIuAD0+77/tlnAI4MCwm9Yd71utUUigYwxp+240lb4XLNxxdIoIPyKtfAO4WOPTmstK0UsLO5qKXwskBX+AYC9AESTfGNOOm34UBrZTgSyH0DVjutVp+JdaaS1PgXgue2kTES5YBjDANt2FEy8tfCuMMYCGWPyzPykYa0Mep73PkzR0Gawwt+zC3LD7q6tLRz12TU6pVSWiGStyKrvmPiw4OC/crkZX1jh1+Uq9n1/Pmyxdue2QcHEt9rCUaHEzPKaJk9Ej63wazYnkYVvagZjzDFm/mZXvQgv7uoqjGG6lLdbR5lZ9pdDRFP1Oz7Mj7s5Q7Ozs4ccx5HMsO/7d4mIuykQ9ux/1P2YaGYN28YAAAAASUVORK5CYII=)  no-repeat !important; right: auto !important;left: 50px !important;"
        ></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </Col>
    </Row>
    <div style="height: 100px;" @mouseenter="clearHover()"></div>
    <div>
      <img class="centerLR" src="../../static/image/hexinyoushi.png" style="width: 20%;" />
    </div>
    <div style="height: 80px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <!-- <Col span="16"> -->
      <!-- <Row> -->
      <div class="cent">
        <div
          class="youshiis"
          v-for="(item,index) in advantageList"
          :key="index"
          @mouseenter="youshi()"
        >
          <div class="alignCenter youshi-ty centerLR curP">{{item.name}}</div>
        </div>
      </div>
      <!-- </Row>
      </Col>-->
    </Row>
    <div style="height: 80px;"></div>
    <div style="position: relative">
      <img id="jindu_back" src="../../static/image/jindu_back.png" style="width: 100%;" />
      <!--<img id="jindu_back" src="http://img5.imgtn.bdimg.com/it/u=2602189933,274353730&fm=26&gp=0.jpg"-->
      <!--style="width: 100%;">-->
      <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;z-index: 99;">
        <div class="BTjuzhongP">
          <div class="BTjuzhongC">
            <div style="padding-bottom: 50px;padding-top: 120px;">
              <img src="../../static/image/jindu_title.png" style="width: 25%;" />
            </div>
            <div
              class="colorW"
              style="padding-bottom: 150px;font-family: 'Microsoft YaHei';font-size: 16px;"
            >制作过程全程沟通，每完成一个环节都会征求客户意见，客户满意后才进行下一环节</div>
            <Row type="flex" justify="center" class="code-row-bg">
              <Col
                id="col_width"
                span="16"
                style="height: 5px;background: white;position: relative;"
              >
                <div
                  id="jindu_div"
                  style="height: 5px;background: #FD8D51;width: 0;transition:width 1s;position: relative;"
                >
                  <img
                    src="../../static/image/shanshan.png"
                    style="width: 20px;position: absolute;right: -8px;top: -8px;"
                  />
                </div>
                <div
                  v-for="(item,index) in jinduList"
                  :key="index"
                  style="position: absolute;bottom: -20px;height: 200px;width: 80px;"
                  :style="{left:item.left}"
                >
                  <table class="fullWidth" style="height: 100%;">
                    <tr>
                      <td valign="bottom">
                        <div>
                          <img :src="item.icon" style="width: 30px;" />
                        </div>
                        <div class="colorW" :class="{colorBA:item.isColor}">{{item.name}}</div>
                        <div>
                          <img class="centerLR" :src="item.icon_sma" style="width: 40px;" />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  v-for="(items,index) in jinduList1"
                  :key="'info2-'+index"
                  style="position: absolute;top: -20px;height: 200px;width: 80px;"
                  :style="{left:items.left}"
                >
                  <table class="fullWidth" style="height: 100%;">
                    <tr>
                      <td valign="top">
                        <div>
                          <img class="centerLR" :src="items.icon_sma" style="width: 40px;" />
                        </div>
                        <div>
                          <img :src="items.icon" style="width: 30px;" />
                        </div>
                        <div class="colorW" :class="{colorBA:items.isColor}">{{items.name}}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 50px;"></div>
    <div>
      <img class="centerLR" src="../../static/image/jishujiagou.png" style="width: 20%;" />
    </div>
    <div style="height: 30px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <Row>
          <Col
            span="4"
            class="alignCenter curP"
            :class="{indexActive:item.isindexActive}"
            v-for="(item,index) in jishuList"
            style="height: 30px;"
            :key="index"
            @mouseenter.native="setin(index)"
            @mouseleave.native="leave()"
          >{{item.name}}</Col>
        </Row>
        <div style="padding:50px;">
          <div class="borders">
            <Row>
              <Col class="jishutext" span="6" offset="1">
                <p class="jishuname">{{name}}</p>
                <p class="jishutext2">{{text2}}</p>
                <p class="jishutext3">{{text3}}</p>
              </Col>
              <Col span="11" offset="6">
                <img class="imgsrc" :src="jishuImg" :class="{imgSH:isImgSH}" />
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <div>
      <img class="centerLR" src="../../static/image/fuwuchengnuo.png" style="width: 20%;" />
    </div>
    <div style="height: 50px;"></div>

    <Row>
      <Col span="4" offset="4">
        <div class="fu1">
          <img src="../../static/ing1/bak1.png" alt />
          <p class="angiou">比自建团队节省50%以上的资金投入，获得更好的作品，技术零风险开展项目，一切将如期而至。</p>
        </div>
      </Col>
      <Col span="4">
        <div class="fu1">
          <img src="../../static/ing1/bak2.png" alt />
          <p class="angiou">比自建团队节省一半时间，不仅保质保量还能尽早发布上线，把我市场先机。</p>
        </div>
      </Col>
      <Col span="4">
        <div class="fu1">
          <img src="../../static/ing1/bak3.png" alt />
          <p class="angiou">你负责思考我们负责执行，完善的思路+百分百的执行=完美的作品，我们与你共同打造。</p>
        </div>
      </Col>
      <Col span="4">
        <div class="fu1">
          <img src="../../static/ing1/bak4.png" alt />
          <p class="angiou">你专业人、做专业事，你想到的，我们提供最优的解决方案，你想不到的我们也一样用心。</p>
        </div>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <div style="position: relative">
      <img id src="../../static/image/hezuo_back1.png" style="width: 100%;" />
      <div style="position: absolute;left: 0;top: 0;bottom: 0;right: 0;">
        <div class="BTjuzhongP">
          <div class="BTjuzhongC">
            <div style="margin-top: 0%;">
              <img src="../../static/image/hezuohuoban.png" style="width: 20%;margin-top: 3%;" />
            </div>
            <div
              class="colorW"
              style="padding-bottom: 40px;font-family: 'Microsoft YaHei';font-size: 16px;margin-top: 2%;"
            >专业团队打造专属精品</div>
            <Row type="flex" justify="center" class="code-row-bg">
              <Col span="3" v-for="(item,index) in hezuoList" :key="index" class="cols">
                <div class="cols2 zfb" style="background: white; border-right: 1px solid #e6e6e6">
                  <div class="BTjuzhongP">
                    <div class="BTjuzhongC">
                      <img class="imgsto animated" :class="{pulse:item.pulse}" :src="item.icon" />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div class="BTjuzhongC">
            <div style="padding-bottom: 0;">
              <img class="styoe" src="../../static/image/hezuohuoban1.png" style="width: 20%;" />
            </div>
            <Row type="flex" justify="center" class="code-row-bg imgoce">
              <Col span="3" v-for="(item,index) in hezuoListone" :key="index" class="cols">
                <div
                  class="cols2 sng"
                  style="background: white;height: 100%;border-right: 1px solid #e6e6e6"
                >
                  <div class="BTjuzhongP">
                    <div class="BTjuzhongC">
                      <img class="imgstwo animated" :class="{pulse:item.pulse}" :src="item.icon" />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 50px;"></div>
    <div>
      <img class="centerLR" src="../../static/image/xinwen.png" style="width: 20%;" />
    </div>
    <div style="height: 50px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col
        span="4"
        class="alignCenter curP"
        v-for="(item,index) in xinwenTitleList"
        :key="index"
        :class="{indexActives:item.indexActives}"
        @click.native="clickNewTitle(index)"
        style="height: 30px;"
      >{{item.name}}</Col>
    </Row>
    <div style="height: 30px;"></div>
    <Row v-show="hangnew" type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <table class="fullWidth">
          <tr>
            <td class="newone" width="100%">
              <div @click="showNews">
                <router-link
                  class="newtt"
                  style="border: 1px solid #e6e6e6;border-top: none"
                  :to="{path:linkTo,query:{newId:new_title1_id}}"
                >
                  <img :src="new_title1_icon" class="fullWidth newimg" />

                  <div
                    class="oneHang newtxt"
                    style="padding:0 15px;margin:15px 0;font-size: 18px;font-family: 'Microsoft YaHei';color: #333333;"
                  >{{new_title1_title}}</div>
                  <div
                    style="padding: 0 15px 0 15px;font-family: 'Microsoft YaHei';color: #999999;font-size: 14px;"
                    class="twoHang newtxt"
                  >{{new_title1_intro}}</div>
                  <div
                    class="newtxt"
                    style="padding: 15px 0 10px 15px;color: #999999;"
                  >{{new_title1_time}}</div>
                </router-link>
              </div>
            </td>
            <td align="center" style="padding-left: 30px;">
              <ul style="list-style: none">
                <li
                  style="border-bottom: 1px solid #e6e6e6;padding: 35px 0 10px 0;"
                  v-for="(item,index) in hangyeList"
                  :key="index"
                >
                  <div @click="showNews">
                    <router-link :to="{path:linkTo,query:{newId:item.id}}">
                      <table class="fullWidth">
                        <tr>
                          <td width="200">
                            <img :src="item.image" class="fullWidth" />
                          </td>
                          <td style="padding-left: 20px;">
                            <div
                              class="curP oneHang"
                              style="font-size: 18px;font-family: 'Microsoft YaHei';color: #333333;margin-bottom: 15px;"
                            >{{item.title}}</div>
                            <div
                              class="twoHang"
                              style="font-size: 14px;color: #999999;font-family: 'Microsoft YaHei';"
                            >{{item.intro}}</div>
                            <div
                              style="font-size: 12px;font-family: 'Microsoft YaHei';color: #999999;padding-top: 10px;"
                            >{{item.time}}</div>
                          </td>
                        </tr>
                      </table>
                    </router-link>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </Col>
    </Row>
    <Row v-show="jianyunnew" type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <table class="fullWidth">
          <tr>
            <td class="onetwo">
              <div @click="showNews">
                <router-link
                  class="newtt"
                  style="border: 1px solid #e6e6e6;border-top: none"
                  :to="{path:linkTo,query:{newId:new_title2_id}}"
                >
                  <div>
                    <img :src="new_title2_icon" class="fullWidth imgnews" />
                  </div>
                  <div
                    class="oneHang"
                    style="padding:0 15px;margin:15px 0;font-size: 18px;font-family: 'Microsoft YaHei';color: #333333;"
                  >{{new_title2_title}}</div>
                  <div
                    style="padding: 0 15px 0 15px;font-family: 'Microsoft YaHei';color: #999999;font-size: 14px;"
                    class="twoHang"
                  >{{new_title2_intro}}</div>
                  <div style="padding: 15px 0 10px 15px;color: #999999;">{{new_title2_time}}</div>
                </router-link>
              </div>
            </td>
            <td class="onetd" align="center" style="padding-left: 30px;">
              <ul style="list-style: none">
                <li
                  style="border-bottom: 1px solid #e6e6e6;padding: 35px 0 10px 0;"
                  v-for="(item,index) in jianyunList"
                  :key="index"
                >
                  <div @click="showNews">
                    <router-link :to="{path:linkTo,query:{newId:item.id}}">
                      <table class="fullWidth">
                        <tr>
                          <td width="200">
                            <img :src="item.image" class="fullWidth" />
                          </td>
                          <td style="padding-left: 20px;">
                            <div
                              class="curP oneHang"
                              style="font-size: 18px;font-family: 'Microsoft YaHei';color: #333333;margin-bottom: 15px;"
                            >{{item.title}}</div>
                            <div
                              class="twoHang"
                              style="font-size: 14px;color: #999999;font-family: 'Microsoft YaHei';"
                            >{{item.intro}}</div>
                            <div
                              style="font-size: 12px;font-family: 'Microsoft YaHei';color: #999999;padding-top: 10px;"
                            >{{item.time}}</div>
                          </td>
                        </tr>
                      </table>
                    </router-link>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <div style="text-align: center">
      <Button>
        <router-link to="/news" @click.native="clickMenu(5)">查看更多 >></router-link>
      </Button>
    </div>
    <div style="height: 50px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
require("../assets/css/main.css");
import Swiper from "swiper";
import $ from "jquery";
import "swiper/dist/css/swiper.min.css";
import Promise from "Promise";
import xfck from "./xfck.vue";
import { setInterval, clearInterval } from "timers";

var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "";
// }
// /jianyunPC
export default {
  name: "hello",
  data() {
    return {
      linkTo: "/newDetail",
      value1: 0,
      numers: 0,
      isGundong: 0,
      isImgSH: false,
      hangnew: true,
      jianyunnew: false,
      new_title1_icon: "",
      new_title1_title: "",
      new_title1_time: "",
      new_title1_intro: "",
      new_title1_id: "",
      new_title2_icon: "",
      new_title2_title: "",
      new_title2_time: "",
      new_title2_intro: "",
      new_title2_id: "",
      jishuImg: img_url_i + "/static/home/0.jpg",
      name: "分布式服务器集群",
      text2: "可无限增加服务器数量，消除单点故障，提升负载能力",
      text3:
        "多台云服务器进行流量分发的负载均衡服务，可以通过流量分发扩展应用系统对外的服务能力，通过消除单点故障提升应用系统的可用性。",
      slideHeight: $(window).width() / 7 + "px",
      shijian: "",
      nuurs: 0,
      slideList: [
        {
          title: "APP开发",
          value: "first",
          icon: img_url_i + "/static/image/appH.png",
          linkTo: "/apps",
          isShow: false,
          children: [{ name: "安卓原生APP" }, { name: "苹果原生APP" }, { name: "H5打包APP" },{name:"uni-app"}]
        },
        {
          title: "网站建设",
          value: "first",
          icon: img_url_i + "/static/image/wangzhanH.png",
          linkTo: "/wangzhan",
          isShow: false,
          children: [{ name: "模板网站" }, { name: "定制网站" },{name:"手机网站"}]
        },
        {
          title: "微信小程序",
          value: "first",
          icon: img_url_i + "/static/image/weixinH.png",
          linkTo: "/weixin",
          isShow: false,
          children: [
            { name: "定制小程序"},
            { name: "展示小程序"},
            { name: "模板小程序"},
             { name: "智能小程序"}
          ]
        },
        {
          title: "HTML5",
          value: "first",
          icon: img_url_i + "/static/image/htmlH.png",
          linkTo: "/htmls",
          isShow: false,
          children: [
            { name: "H5传单" },
            { name: "H5营销" },
            { name: "H5移动官网" },
            { name: "H5定制系统" }
          ]
        },
        {
          title: "美术设计",
          value: "first",
          icon: img_url_i + "/static/image/shejiH.png",
          linkTo: "/sheiji",
          isShow: false,
          children: [
            { name: "视觉设计" },
            { name: "交互设计" },
            { name: "用户体验" }
          ]
        },
        {
          title: "模板系统",
          value: "moban",
          icon: img_url_i + "/static/image/mobanH.png",
          linkTo: "/",
          isShow: false,
          children: [
            { name: "商城模板系统"},
            { name: "门店会员系统"},
            { name: "销售获客系统"},
            { name: "智能点餐系统"}
          ]
        }
      ],
      advantageList: [
        { name: "全球网络加速", isHover: false },
        { name: "风控应急预案", isHover: false },
        { name: "全天运维守护", isHover: false },
        { name: "无限负载能力", isHover: false },
        { name: "专业团队", isHover: false },
        { name: "金质服务", isHover: false },
        { name: "分布式架构", isHover: false },
        { name: "模块化设计", isHover: false },
        { name: "全面数据统计", isHover: false },
        { name: "财务安全机制", isHover: false },
        { name: "多重安全保障", isHover: false },
        { name: "商业保密机制", isHover: false }
      ],
      jinduList: [
        {
          name: "沟通需求",
          icon: img_url_i + "/static/image/goutong.png",
          icon_sma: img_url_i + "/static/image/jindu_1.png",
          left: -40 + "px",
          isColor: true
        },
        {
          name: "签订协议",
          icon: img_url_i + "/static/image/xieyi1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.22 - 40 + "px",
          isColor: false
        },
        {
          name: "客户确认",
          icon: img_url_i + "/static/image/queren1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.44 - 40 + "px",
          isColor: false
        },
        {
          name: "内部测试",
          icon: img_url_i + "/static/image/ceshi1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.66 - 40 + "px",
          isColor: false
        },
        {
          name: "上线运行",
          icon: img_url_i + "/static/image/shangxian1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.88 - 40 + "px",
          isColor: false
        }
      ],
      jinduList1: [
        {
          name: "制定解决方案",
          icon: img_url_i + "/static/image/fangan1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.11 - 40 + "px",
          isColor: false
        },
        {
          name: "产品和UI设计",
          icon: img_url_i + "/static/image/sheji1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.33 - 40 + "px",
          isColor: false
        },
        {
          name: "技术开发",
          icon: img_url_i + "/static/image/kaifa1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.55 - 40 + "px",
          isColor: false
        },
        {
          name: "客户确认",
          icon: img_url_i + "/static/image/queren1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 0.77 - 40 + "px",
          isColor: false
        },
        {
          name: "售后服务",
          icon: img_url_i + "/static/image/shouhou1.png",
          icon_sma: img_url_i + "/static/image/jindu_2.png",
          left: $("#col_width").width() * 1 - 40 + "px",
          isColor: false
        }
      ],
      jishuList: [
        {
          name: "分布式服务器集群",
          isindexActive: true,
          img: img_url_i + "/static/home/4.jpg",

          text2: "可无限增加服务器数量，消除单点故障，提升负载能力",
          text3:
            "多台云服务器进行流量分发的负载均衡服务，可以通过流量分发扩展应用系统对外的服务能力，通过消除单点故障提升应用系统的可用性。"
        },
        {
          name: "读写分离数据库集群",
          isindexActive: false,
          img: img_url_i + "/static/home/2.jpg",
          text2: "高安全等级，保证数据库安全性",
          text3:
            "提供稳定、高性能、安全可靠的数据库服务针对电商秒杀场景进行专项优化，解决热点数据的高并发更新性能瓶颈，100倍性能提升。通过高安全模式，内置SQL注入检测模块，实时拦截风险SQL，保护数据安全。"
        },
        {
          name: "Redis/MemCached缓存",
          isindexActive: false,
          img: img_url_i + "/static/home/0.jpg",

          text2: "支持缓存、文档、列式存储类等数据库，轻松应对业务突发增长",
          text3:
            "Redis提供持久化的内存数据库服务，基于高可靠双机热备架构及可无缝扩展的集群架构，满足高读写性能场景及容量需弹性变配的业务需求"
        },
        {
          name: "全球CDN网络加速",
          isindexActive: false,
          img: img_url_i + "/static/home/5.jpg",
          text2: "全球1300+ 节点，国内完整覆盖 34 个省级区域。",
          text3:
            "将源站内容分发至最接近用户的节点，使用户可就近取得所需内容，提高用户访问的响应速度和成功率。解决因分布、带宽、服务器性能带来的访问延迟问题，适用于站点加速、点播、直播等场景。"
        },
        {
          name: "无限储存空间",
          isindexActive: false,
          img: img_url_i + "/static/home/6.jpg",
          text2: "提供更低成本、易扩展的存储服务",
          text3:
            "海量、安全、低成本、高可靠的云存储服务，提供99.999999999%的数据可靠性。使用RESTful API 可以在互联网任何位置存储和访问，容量和处理能力弹性扩展，多种存储类型供选择全面优化存储成本"
        },
        {
          name: "多重网络安全保障",
          isindexActive: false,
          img: img_url_i + "/static/home/3.jpg",
          text2: "web应用防火墙、堡垒机、安骑士、数据库审计",
          text3:
            "对网站或者APP的业务流量进行恶意特征识别及防护，将正常、安全的流量回源到服务器。避免网站服务器被恶意入侵，保障业务的核心数据安全，解决因恶意攻击导致的服务器性能异常问题。"
        }
      ],
      hezuoListone: [
        { name: "1", icon: img_url_i + "/static/img2/sl1.png" },
        { name: "2", icon: img_url_i + "/static/img2/nk1.png" },
        { name: "3", icon: img_url_i + "/static/img2/zh1.png" },
        { name: "4", icon: img_url_i + "/static/img2/cl1.png" },
        { name: "5", icon: img_url_i + "/static/img2/ts1.png" }
      ],
      hezuoList: [
        { name: "1", icon: img_url_i + "/static/img2/zf1.png" },
        { name: "2", icon: img_url_i + "/static/img2/al1.png" },
        { name: "3", icon: img_url_i + "/static/img2/hw1.png" },
        { name: "4", icon: img_url_i + "/static/img2/wx1.png" },
        { name: "5", icon: img_url_i + "/static/img2/yq1.png" }
      ],
      xinwenTitleList: [
        { name: "行业新闻", indexActives: true },
        { name: "简云课堂", indexActives: false }
      ],
      hangyeList: [],
      jianyunList: []
    };
  },
  mounted() {
    var that = this;
    // that.slideHeight = ;
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    that.jinduList.map(function(item, index) {
      item.left = $("#col_width").width() * (0.22 * index) - 40 + "px";
    });
    that.jinduList1.map(function(item, index) {
      if (index === 4) {
        item.left = $("#col_width").width() * 1 - 40 + "px";
      } else {
        item.left = $("#col_width").width() * (0.22 * index + 0.11) - 40 + "px";
      }
    });
    that.jinduGo();
    // $(".hello").scroll(function () {
    //   var top1 = $('#jindu_back').offset().top;
    //   var gun = $(document).scrollTop();
    //   var top = top1 - gun;
    //   if (that.isGundong === 0) {
    //     if (top <= 200) {
    //       that.isGundong = 1;
    //       that.jinduGo();
    //     }
    //   }
    // });
    // this.axios({
    //   method: 'post',
    //   url: that.baseUrl + '/jianyunadmin/api.php?c=business_news_list',
    //   data: {
    //     region: 5
    //   },
    //   success: function (e) {
    //     console.log(e);
    //   }
    // })
    var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
    that.axios
      .get(url, { params: { region: 5, page: 1 } })
      .then(res => {
        that.new_title1_icon = that.getData.CDN_IMG + res.data.data[0].image;
        that.new_title1_title = res.data.data[0].title;
        that.new_title1_intro = res.data.data[0].intro;
        that.new_title1_id = res.data.data[0].id;
        that.new_title1_time = that.getData.timetrans(res.data.data[0].time);
        res.data.data.forEach(function(item, index) {
          if (index !== 0) {
            if (index < 4) {
              item.time = that.getData.timetrans(item.time);
              item.image = that.getData.CDN_IMG + item.image;
              that.hangyeList.push(item);
            }
          }
        });
      })
      .catch(error => {
        console.log(error);
      });
    that.axios
      .get(url, { params: { region: 6, page: 1 } })
      .then(res => {
        that.new_title2_icon = that.getData.CDN_IMG + res.data.data[0].image;
        that.new_title2_title = res.data.data[0].title;
        that.new_title2_intro = res.data.data[0].intro;
        that.new_title2_id = res.data.data[0].id;
        that.new_title2_time = that.getData.timetrans(res.data.data[0].time);
        res.data.data.forEach(function(item, index) {
          if (index !== 0) {
            if (index < 4) {
              item.time = that.getData.timetrans(item.time);
              item.image = that.getData.CDN_IMG + item.image;
              that.jianyunList.push(item);
            }
          }
        });
      })
      .catch(error => {
        console.log(error);
      });
  },
  created() {
    this.enterJishu();
  },
  methods: {
    showNews() {
      this.$parent.changeNavStatus(5);
    },
    clickMenu(index) {
      this.$parent.clickMenu(index);
    },
    jiapng(type) {
      var that = this;
      that.hezuoListone[type].pulse = false;
    },
    jiapngtwo(type) {
      var that = this;
      that.hezuoList[type].pulse = false;
    },
    hoverThis(index) {
      var that = this;
      that.slideList.map(function(item) {
        item.isShow = false;
      });
      that.slideList[index].isShow = true;
    },
    youshi(index) {
      var that = this;
    },
    clearHover() {
      var that = this;
      that.slideList.map(function(item) {
        item.isShow = false;
      });
    },
    jinduGo() {
      let that = this;
      that.nums = 1;
      clearInterval(dtime1);
      $("#jindu_div").css("width", "0");
      var dtime1 = setInterval(function() {
        that.setCookie("dtime1", dtime1);
        $("#jindu_div").css("width", that.nums * 11 + "%");
        if (that.nums % 2 === 0) {
          let cNum = that.nums / 2;
          var dtime2 = setTimeout(function() {
            that.jinduList[cNum].isColor = true;
            that.jinduList[cNum].icon_sma =
              img_url_i + "/static/image/jindu_1.png";
            that.jinduList[cNum].icon = that.jinduList[cNum].icon.replace(
              /1.png/g,
              ".png"
            );
            clearTimeout(dtime2);
          }, 900);
        } else {
          let cNum = (that.nums - 1) / 2;
          var dtime3 = setTimeout(function() {
            that.jinduList1[cNum].isColor = true;
            that.jinduList1[cNum].icon_sma =
              img_url_i + "/static/image/jindu_1.png";
            that.jinduList1[cNum].icon = that.jinduList1[cNum].icon.replace(
              /1.png/g,
              ".png"
            );
            clearTimeout(dtime3);
          }, 900);
        }
        if (that.nums === 9) {
          $("#jindu_div").css("width", "100%");
          clearInterval(dtime1);
          var dtime4 = setTimeout(function() {
            $("#jindu_div").css("width", "0");
            that.jinduList1 = [
              {
                name: "制定解决方案",
                icon: img_url_i + "/static/image/fangan1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.11 - 40 + "px",
                isColor: false
              },
              {
                name: "产品和UI设计",
                icon: img_url_i + "/static/image/sheji1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.33 - 40 + "px",
                isColor: false
              },
              {
                name: "技术开发",
                icon: img_url_i + "/static/image/kaifa1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.55 - 40 + "px",
                isColor: false
              },
              {
                name: "客户确认",
                icon: img_url_i + "/static/image/queren1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.77 - 40 + "px",
                isColor: false
              },
              {
                name: "售后服务",
                icon: img_url_i + "/static/image/shouhou1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 1 - 40 + "px",
                isColor: false
              }
            ];
            that.jinduList = [
              {
                name: "沟通需求",
                icon: img_url_i + "/static/image/goutong.png",
                icon_sma: img_url_i + "/static/image/jindu_1.png",
                left: -40 + "px",
                isColor: true
              },
              {
                name: "签订协议",
                icon: img_url_i + "/static/image/xieyi1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.22 - 40 + "px",
                isColor: false
              },
              {
                name: "客户确认",
                icon: img_url_i + "/static/image/queren1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.44 - 40 + "px",
                isColor: false
              },
              {
                name: "内部测试",
                icon: img_url_i + "/static/image/ceshi1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.66 - 40 + "px",
                isColor: false
              },
              {
                name: "上线运行",
                icon: img_url_i + "/static/image/shangxian1.png",
                icon_sma: img_url_i + "/static/image/jindu_2.png",
                left: $("#col_width").width() * 0.88 - 40 + "px",
                isColor: false
              }
            ];
            that.nums = 1;
            clearTimeout(dtime4);
            that.jinduGo();
          }, 900);
        }
        that.nums++;
      }, 1000);
    },
    leave() {
      this.enterJishu();
    },
    setin(index) {
      clearInterval(this.timer);
      this.numers = index;
      clearTimeout(alhfasdd);
      var that = this;
      that.jishuList.map(function(item) {
        item.isindexActive = false;
      });
      that.jishuList[this.numers].isindexActive = true;
      that.name = that.jishuList[this.numers].name;
      that.text2 = that.jishuList[this.numers].text2;
      that.text3 = that.jishuList[this.numers].text3;
      that.jishuImg = that.jishuList[this.numers].img;
      that.isImgSH = true;
      var alhfasdd = setTimeout(function() {
        that.isImgSH = false;
      }, 300);
    },
    enterJishu() {
      clearInterval(this.timer);
      this.timer = setInterval(res => {
        this.numers++;
        clearTimeout(alhfasdd);
        var that = this;
        that.jishuList.map(function(item) {
          item.isindexActive = false;
        });
        that.jishuList[this.numers].isindexActive = true;
        that.name = that.jishuList[this.numers].name;
        that.text2 = that.jishuList[this.numers].text2;
        that.text3 = that.jishuList[this.numers].text3;
        that.jishuImg = that.jishuList[this.numers].img;
        that.isImgSH = true;
        var alhfasdd = setTimeout(function() {
          that.isImgSH = false;
        }, 300);
        if (this.numers == 5) {
          this.numers = -1;
        }
      }, 3000);
    },
    //滑动
    hezuoEnterone(index) {
      var that = this;
      that.hezuoListone.map(function(item) {
        item.pulse = false;
      });
      that.hezuoListone[index].pulse = true;
    },
    hezuoEnter(index) {
      var that = this;
      that.hezuoList.map(function(item) {
        item.pulse = false;
      });
      that.hezuoList[index].pulse = true;
    },
    clickNewTitle(index) {
      var that = this;
      that.xinwenTitleList.map(function(item) {
        item.indexActives = false;
        item.news = false;
      });
      if (index === 0) {
        that.jianyunnew = false;
        that.hangnew = true;
      } else {
        that.jianyunnew = true;
        that.hangnew = false;
      }
      that.xinwenTitleList[index].indexActives = true;
    },
    setCookie(name, value, time, path) {
      var exp = new Date();
      path = path || "/";
      var cval;
      if (time === 0) {
        exp.setTime(exp.getTime() - 1);
        cval = getCookie(name);
      } else {
        cval = encodeURIComponent(value);
        var Days = 30;
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      }
      if (cval != null) {
        document.cookie =
          name + "=" + cval + ";path=" + path + ";expires=" + exp.toGMTString();
      }
    },
    getCookie(name) {
      var strCookie = document.cookie;
      var arrCookie = strCookie.split("; ");
      for (var i = 0; i < arrCookie.length; i++) {
        var arr = arrCookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    clickMoban(index) {
      var that = this;
      if (that.slideList[index].value === "moban") {
        return (window.location.href = "http://www.jianyunkeji.net/");
      }
      this.$parent.clickTwoMenu(index);
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
::v-deep .nbcol {
  height: 220px !important;
}
::v-deep {
  height: 220px !important;
}
::v-deep .nbbanner {
  height: 220px !important;
}
::v-deep .bnn {
  height: 220px !important;
}
.cent {
  width: 1000px;
}
.youshiis {
  float: left;
  margin-left: 15px;
  margin-top: 15px;
  width: 150px;
  height: 100px;
}
/* .youshiis:nth-child(1){
  margin-left: 20px;
} */
.youshi-ty {
  width: 150px;
}
.BTjuzhongC {
  display: block;
  height: 30%;
}
.BTjuzhongP {
  overflow: hidden;
}
.styoe {
  margin-top: 10%;
}
.imgsto {
  margin: 15% 0;
  width: 85%;
}
.imgsrc {
  width: 90%;
  margin: 60px 0;
}
.jishutext {
  margin-top: 10%;
  margin-bottom: 15%;
}
.jishuname {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}
.jishutext2 {
  margin-top: 10%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}
.jishutext3 {
  margin-top: 10%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.borders {
  border: 2px solid #f1efef;
}

.imgstwo {
  margin: 15% 0;
}

.cols:nth-child(2) > .cols2 > .BTjuzhongP > .BTjuzhongC .imgstwo {
  margin-top: 50px;
  width: 70%;
}
.imgoce {
  margin-top: 2%;
}
.zfb {
  height: 100%;
}
.zfb:hover .imgsto {
  transform: translate(0, -5px);
  transition: all ease 0.4s;
}
.sng:hover .imgstwo {
  transform: translate(0, -5px);
  transition: all ease 0.4s;
}
.newone {
  margin-top: 9%;
  display: block;
}
.onetwo {
  display: block;
  width: 130%;
  margin-top: 10%;
}
.onetd {
  margin-left: 0px;
  width: 80%;
  transform: translateX(15%);
}
.newimg {
  height: 370px;
}
.imgnews {
  height: 375px;
}
.angiou {
  margin-top: 40px;
  margin-bottom: 20px;
  width: 200px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/hello.vue